import React from 'react'
import style from './Login.module.css';
import logo from '../../assets/logo/logo.svg';

export default function Login() {

  // 로그인 구현 해야 함
  const loginBtnHandler = () => {
  }

  return <>
    <div className={style.body}>
      <div className={style.container}>
        <div className={style.wrapper}>
          <div className={style.logoArea}>
            <img src={logo} alt="로고" />
            <div className={style.title}>관리자 페이지</div>
          </div>
          <div className={style.loginInputArea}>
            <div className={style.inputGroup}>
              <div className={style.inputLabel}>
                이메일
                <input type="text" placeholder='로그인에 사용할 이메일을 입력해주세요.' />
              </div>
              <div className={style.inputLabel}>
                비밀번호
                <input type="password" placeholder='비밀번호를 입력해주세요.' />
              </div>
            </div>
            <div className={style.buttonArea}>
              <button className={style.loginBtn} onClick={loginBtnHandler}>로그인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
}